__webpack_require__.p = "//yastatic.net/pcode-static/inspire/";